import React from 'react';
import * as Yup from 'yup';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import numeral from 'numeral';

const amountMin = 1;
const amountMax = 99999999.99;

const reinvestMax = 100;
const reinvestMin = 0;

const interestMax = 500;
const interestMin = 50;

export default Yup.object().shape({
  total_amount: Yup.number()
    .nullable()
    .typeError(
      <FormattedMessage
        id="onboarding_aml_form_bad_value"
        defaultMessage={dlt['onboarding_aml_form_bad_value']}
      />
    )
    .min(
      amountMin,
      <FormattedMessage
        id="onboarding_aml_form_min_value"
        defaultMessage={dlt['onboarding_aml_form_min_value']}
        values={{ value: numeral(amountMin).format('0,00.00'), currency: ' €' }}
      />
    )
    .max(
      amountMax,
      <FormattedMessage
        id="onboarding_aml_form_max_value"
        defaultMessage={dlt['onboarding_aml_form_max_value']}
        values={{ value: numeral(amountMax).format('0,00.00'), currency: ' €' }}
      />
    ),

  reinvest_agreement: Yup.boolean(),
  reinvest_rate: Yup.number()
    .when('reinvest_agreement', {
      is: true,
      then: Yup.number().required(
        <FormattedMessage
          id="onboarding_personal_form_required"
          defaultMessage={dlt['onboarding_personal_form_required']}
        />
      ),
    })
    .nullable()
    .typeError(
      <FormattedMessage
        id="onboarding_aml_form_bad_value"
        defaultMessage={dlt['onboarding_aml_form_bad_value']}
      />
    )
    /*   .required(
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />
    ) */
    .min(
      reinvestMin,
      <FormattedMessage
        id="onboarding_aml_form_min_value"
        defaultMessage={dlt['onboarding_aml_form_min_value']}
        values={{ value: reinvestMin, currency: '%' }}
      />
    )
    .max(
      reinvestMax,
      <FormattedMessage
        id="onboarding_aml_form_max_value"
        defaultMessage={dlt['onboarding_aml_form_max_value']}
        values={{ value: reinvestMax, currency: '%' }}
      />
    ),

  /*   consent_to_repurchase_of_receivables: Yup.boolean(), */
  max_investment: Yup.number()
    .nullable()
    .typeError(
      <FormattedMessage
        id="onboarding_aml_form_bad_value"
        defaultMessage={dlt['onboarding_aml_form_bad_value']}
      />
    )
    .required(
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />
    )
    .min(
      interestMin,
      <FormattedMessage
        id="onboarding_aml_form_min_value"
        defaultMessage={dlt['onboarding_aml_form_min_value']}
        values={{ value: interestMin, currency: ' €' }}
      />
    )
    .max(
      interestMax,
      <FormattedMessage
        id="onboarding_aml_form_max_value"
        defaultMessage={dlt['onboarding_aml_form_max_value']}
        values={{ value: interestMax, currency: ' €' }}
      />
    ),

  the_purpose_is_to_enhance_funding_additional_info: Yup.string().when(
    'the_purpose_is_to_enhance_funding',
    {
      is: false,
      then: Yup.string().required(
        <FormattedMessage
          id="onboarding_personal_form_required"
          defaultMessage={dlt['onboarding_personal_form_required']}
        />
      ),
      otherwise: Yup.string(),
    }
  ),

  final_consumer: Yup.boolean(),
  politically_exposed: Yup.boolean(),
  sanctioned: Yup.boolean(),
  own_interest: Yup.boolean(),
  the_purpose_is_to_enhance_funding: Yup.boolean(),
  the_funds_do_not_come_from_illegal_sources: Yup.boolean().oneOf(
    [true],
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ),
  agreed_terms: Yup.boolean().oneOf(
    [true],
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ),
  agreement_with_the_fee_schedule: Yup.boolean().oneOf(
    [true],
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ),
});
